// extracted by mini-css-extract-plugin
export default {"addVoucher":"PaymentInfo_addVoucher__Rsi3W","voucherInput":"PaymentInfo_voucherInput__mg51P"};